// This file is automatically generated. Do not edit manually.

import { CustomerOrderPackageState } from "src/api/generated/erp/db/types/enums/customerOrderPackageState";
import { CustomerOrderPackageView } from "src/api/generated/erp/db/types/tables/customerOrderPackageView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderPackageDataGridApi {
	export async function getCustomerOrderPackages(args: {
		customerOrderId: number;
		stateFilter?: Array<CustomerOrderPackageState>;
	}): Promise<Array<CustomerOrderPackageView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/picking/customerOrderPackagesDataGrid/getCustomerOrderPackages",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				stateFilter: args.stateFilter,
			},
		});
		return response as Array<CustomerOrderPackageView>;
	}

	export async function delete_(args: {
		customerOrderPackages: Array<CustomerOrderPackageView>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/picking/customerOrderPackagesDataGrid/delete",
			method: "POST",
			data: {
				customerOrderPackages: args.customerOrderPackages,
			},
		});
		return response as void;
	}
}
